import { selectEntitiesMissionsEntityFormatRules } from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { type Selector } from '../../../../types/selectors';
import { createResultEqualSelector } from '../../../../utils/reselect';
import { type MissionFormatRule } from '../../types/state/missions';

type MissionsDetailsRuleListPropsType = {
  formatRules: Array<MissionFormatRule>;
};

const selectMissionDetailsRuleListProps: Selector<MissionsDetailsRuleListPropsType> = createResultEqualSelector(
  [selectEntitiesMissionsEntityFormatRules],
  (formatRules) => ({
    formatRules,
  }),
);

export default selectMissionDetailsRuleListProps;
